import React, { Suspense, useRef, useState } from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, Stage } from "@react-three/drei";
import { Instances, Model } from "./Model.tsx";
export default function Viewer() {
  const [emailSubmitted, setEmailSubmitted] = useState(false);
  const ref = useRef();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100vw",
        minHeight: "100vh",
        textAlign: "center",
        justifyContent: "space-between",
        padding: "20px",
      }}
    >
      <nav
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          width: "80%",
          position: "fixed",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <img style={{ width: 150 }} src="icon5.png" />

          <h2 className="fs2"></h2>
        </div>
        <h2 className="fs2">picnic - simple local AI</h2>
      </nav>
      <div></div>
      <div
        style={{
          width: "50vw",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "20px",
        }}
      >
        {emailSubmitted ? (
          <>
            <h2 className="fs4">download picnic</h2>
            <div
              style={{
                display: "flex",
              }}
            >
              <a
                href="https://picnic-ai.s3.amazonaws.com/0.4.1/Picnic-0.4.1+Setup.exe"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img style={{ width: 200 }} src="windows.png" />
                <h3 className="fs2">picnic for Windows</h3>
                <span>v 0.4.1</span>
              </a>
              <a
                // href="https://picnic-ai.s3.amazonaws.com/0.4.1/Picnic-darwin-arm64-0.4.1.zip"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img style={{ width: 200 }} src="macos.png" />
                <h3
                  className="fs2"
                  style={{
                    textDecoration: "line-through",
                  }}
                >
                  picnic for MacOS
                </h3>
                <span>coming soon</span>
              </a>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <p>
                <span style={{ color: "red" }}>⚠</span> picnic is not yet
                certified by Microsoft, so you may see a warning about a virus
                when you download it. picnic is not a virus, and we are working
                to get it certified as soon as possible.
              </p>
              {/* <p>
                <span style={{ color: "red" }}>⚠</span> mac users may see a warning
                about picnic being from an unidentified developer. you can still run
                picnic by right clicking on the app and selecting "open".
              </p> */}
              <p>
                if you have any questions or concerns, please email us at
                dont@forgetmy.email
              </p>
            </div>
          </>
        ) : (
          <>
            <img style={{ width: "80%" }} src="screenshot.png" />
            <form
              action="https://formspree.io/f/mrgvrngg"
              method="POST"
              style={{
                display: "flex",
                gap: "10px",
              }}
              onSubmit={(e) => {
                e.preventDefault();
                // send POST request to formspree
                fetch("https://formspree.io/f/mrgvrngg", {
                  method: "POST",
                  body: new FormData(e.target),
                  headers: {
                    Accept: "application/json",
                  },
                })
                  .then((response) => {
                    console.log(response);
                    alert("Thanks for your submission!");
                    setEmailSubmitted(true);
                  })
                  .catch((error) => {
                    console.error(error);
                    alert("Sorry, there was an error.");
                  });
              }}
            >
              <input
                type="email"
                name="email"
                style={{
                  padding: "20px",
                  border: "2px solid lime",
                  fontSize: "20px",
                  borderRadius: "10px",
                  width: "40vw",
                }}
                placeholder="🐝 drop your email for free picnic access forever"
                required
              />
              <button
                type="submit"
                style={{
                  padding: "20px",
                  border: "none",
                  fontSize: "20px",
                  borderRadius: "10px",
                  backgroundColor: "black",
                  color: "white",
                }}
              >
                submit
              </button>
            </form>
          </>
        )}
        <div></div>
      </div>
      <div></div>
    </div>
  );
}
